import http from "./axios_client";
import { apiCaller } from "./metruyenvl_caller";

const chapterAPI = {
    async getDetail(slug: string) {
        return apiCaller("/book", "get", {
            query: { slug: slug },
            header: {
                Authorization: "",
            },
        });
    },

    async getChapters(bookID: string, offset?: number, limit?: number) {
        return apiCaller("/chapter/book/id/{book_id}", "get", { path: { book_id: bookID }, query: { offset: offset, limit: limit } });
    },

    async getChaptersByMangaSlug(bookSlug: string, offset?: number, limit?: number) {
        return apiCaller("/chapter/book/{book_slug}", "get", { path: { book_slug: bookSlug }, query: { offset: offset, limit: limit } });
    },

    async getChaptersLatestByMangaSlug(bookSlug?: string) {
        return apiCaller("/chapter/latest/book", "get", { query: { slug: bookSlug } });
    },
};

export default chapterAPI;
